// hooks/useScrollLoader.js
import { createRoot } from "react-dom/client";
import { CircularProgress } from "@mui/material";

const useScrollLoader = (
  CustomLoader = <CircularProgress sx={{ color: "#46A091" }} />
) => {
  const loaderElementRef = document.createElement("div");
  let loaderRoot = null;

  loaderElementRef.style.display = "flex";
  loaderElementRef.style.justifyContent = "center";
  loaderElementRef.style.alignItems = "center";
  loaderElementRef.style.padding = "20px";
  loaderElementRef.style.width = "100%";

  const mountLoader = (container) => {
    if (!container || container.contains(loaderElementRef)) return;

    container.appendChild(loaderElementRef);
    loaderRoot = createRoot(loaderElementRef);
    loaderRoot.render(CustomLoader);
  };

  const unmountLoader = () => {
    if (loaderRoot) {
      loaderRoot.unmount();
      loaderElementRef.remove();
      loaderRoot = null;
    }
  };

  return { mountLoader, unmountLoader };
};

export default useScrollLoader;
